import classNames from "classnames";
import React, { type ReactNode, useMemo } from "react";
import type { BsPrefixProps, BsPrefixRefForwardingComponent } from "react-bootstrap/esm/helpers";
import { ListUi3Context, ListUi3ContextDefaultValue } from "./ListUi3Context";
import { useBootstrapPrefix } from "./ThemeProvider";

export interface ListUi3Props extends BsPrefixProps, React.HTMLAttributes<HTMLElement> {
	listItemStyle?: ReactNode;
	gutterSize?: "sm" | "md";
}

export const ListUi3: BsPrefixRefForwardingComponent<"ul", ListUi3Props> = React.forwardRef<HTMLElement, ListUi3Props>(
	(
		{
			as: Component = "ul",
			bsPrefix,
			className,
			gutterSize = "md",
			listItemStyle = ListUi3ContextDefaultValue.listItemStyle,
			...props
		},
		ref,
	) => {
		bsPrefix = useBootstrapPrefix(bsPrefix, "ui3-list");
		const contextValue = useMemo(() => ({ listItemStyle }), [listItemStyle]);

		return (
			<ListUi3Context.Provider value={contextValue}>
				<Component
					ref={ref}
					className={classNames(className, bsPrefix, gutterSize && `${bsPrefix}-${gutterSize}`)}
					{...props}
				/>
			</ListUi3Context.Provider>
		);
	},
);
